import React, {useContext, useEffect, useState} from "react";
import {TranslateContext} from "../../../context/TranslateContext";
import {MobileContext} from "../../../context/MobileContext";
import {useHistory} from "react-router-dom";
import {AuthContext} from "../../../context/AuthContext";
import {FiltersContext} from "../../../context/FiltersContext";
import {isNumber} from "chart.js/helpers";
import {getListaKpiApi, getstrutturaGerarchicaKpiApi} from "../services/KpiServices";
import {getStatiKpiApi} from "../../stati_kpi/services/StatiServices";
import ListKpiView from "./ListKpiView";
import FiltroRicercaKpiController from "./components/FiltroRicercaKpiController";
import AlberoStrutturaKpiController from "./components/AlberoStrutturaKpiController";

export default function ListKpiController({
                                              categoria
                                          }) {

    const [loadingData, setLoadingData] = useState(true);
    const [kpi, setKpi] = useState([]);
    const [treeData, setTreeData] = useState([]);
    const [statiKpi, setStatiKpi] = useState([]);
    const [totPagine, setTotPagine] = useState();
    const [totKpi, setTotKpi] = useState();
    const [orderByCol, setOrderByCol] = useState();
    const [orderByDir, setOrderByDir] = useState();

    const {annoKpi} = useContext(AuthContext);
    const {filtroKpi, updateFiltroKpi, initFiltroKpi} = useContext(FiltersContext);
    const history = useHistory();

    const {isMobile} = useContext(MobileContext);
    const {translate, lingua, loadingNewLang} = useContext(TranslateContext);

    async function getListaKpi() {
        let f = '?addTipi=1&pag=' + filtroKpi.pagina;
        if (categoria && categoria !== '') {
            f += `&categoria=${categoria}`;
        }

        if (filtroKpi.kpiSel) {
            f += '&id_elemento=' + filtroKpi.kpiSel.id;
            f += '&tipo_ricerca=' + filtroKpi.kpiSel.tipo;
        }
        if (filtroKpi.id_stato_kpi && filtroKpi.id_stato_kpi !== '') {
            f += '&id_stato_kpi=' + filtroKpi.id_stato_kpi;
        }
        if (filtroKpi.codice && filtroKpi.codice !== '') {
            f += '&codice=' + filtroKpi.codice;
        }
        if (filtroKpi.descrizione && filtroKpi.descrizione !== '') {
            f += '&descrizione=' + filtroKpi.descrizione;
        }
        if (filtroKpi.tipo_imp_dati && filtroKpi.tipo_imp_dati !== '') {
            f += '&tipo_imp_dati=' + filtroKpi.tipo_imp_dati;
        }
        if (filtroKpi.stato_kpi && filtroKpi.stato_kpi !== '') {
            f += '&stato_kpi=' + filtroKpi.stato_kpi;
        }
        if (orderByCol && orderByCol !== '' && orderByDir && orderByDir !== '') {
            f += `&orderByCol=${orderByCol}&orderByDir=${orderByDir}`;
        }
        const response = await getListaKpiApi(f);
        setKpi(response.data.data);
        setTotPagine(response.data.pages);
        setTotKpi(response.data.tot);

        if (loadingData) {
            getStruttura();
        }
        setLoadingData(false);
    }

    async function getStatiKpi() {
        const response = await getStatiKpiApi();
        setStatiKpi(response.data.data);
    }

    async function getStruttura() {
        let idSel = filtroKpi.kpiSel ? filtroKpi.kpiSel.id_elemento : 0;
        const response = await getstrutturaGerarchicaKpiApi(idSel, categoria);
        setTreeData(response.data.data?.struttura);
    }

    useEffect(() => {
        if (loadingNewLang === false) {
            if (loadingData) {
                getStatiKpi()
            }

            if (filtroKpi.pagina && isNumber(filtroKpi.pagina)) {
                getListaKpi();
            }
        }
    }, [lingua, loadingNewLang, filtroKpi.kpiSel, annoKpi, filtroKpi.pagina, filtroKpi.id_stato_kpi, orderByCol, orderByDir]);

    function getAlberoStruttura() {
        return <AlberoStrutturaKpiController
            filtroKpi={filtroKpi}
            translate={translate}
            updateFiltroKpi={updateFiltroKpi}
            treeData={treeData}
        />;
    }

    function getFiltriListKpi() {
        return <FiltroRicercaKpiController
            filtroKpi={filtroKpi}
            getListaKpi={getListaKpi}
            statiKpi={statiKpi}
            updateFiltroKpi={updateFiltroKpi}
            translate={translate}
            initFiltroKpi={initFiltroKpi}
        />;
    }

    function onRowKpiClicked(row) {
        history.push("/info-kpi/" + row.id_kpi + '/' + row.id_tipo_imp_dati)
    }

    function onOrderByKpi(colonna, direzione) {
        setOrderByCol(colonna);
        setOrderByDir(direzione);
    }

    return (
        !loadingData &&
        <ListKpiView
            orderByDir={orderByDir}
            kpi={kpi}
            totKpi={totKpi}
            getFiltriListKpi={getFiltriListKpi}
            orderByCol={orderByCol}
            translate={translate}
            updateFiltroKpi={updateFiltroKpi}
            getAlberoStruttura={getAlberoStruttura}
            isMobile={isMobile}
            statiKpi={statiKpi}
            totPagine={totPagine}
            filtroKpi={filtroKpi}
            getListaKpi={getListaKpi}
            onRowKpiClicked={onRowKpiClicked}
            onOrderByKpi={onOrderByKpi}
        />
    );
}
